import {useCallback, useRef} from "react";

const TAP_WINDOW_MS = 500;

//iPad 上 dblclick 不一定會觸發（雙擊常被瀏覽器吃掉做縮放），自行用兩次點擊間隔判斷
export default function useDoubleTap(onDoubleTap, windowMs = TAP_WINDOW_MS) {
  const last = useRef(0);
  return useCallback((event) => {
    const now = Date.now();
    if (now - last.current <= windowMs) {
      last.current = 0;
      onDoubleTap(event);
      return;
    }
    last.current = now;
  }, [onDoubleTap, windowMs]);
}